
function svgToCanvas(svg, canvas, xdest, ydest, dpr) {
    let ctx = canvas.getContext('2d');
    const svg_rect = svg.getBoundingClientRect();

    ctx.save();
    svg.querySelectorAll('rect').forEach((rect, irect) => {
        if (rect.classList.length > 0 && rect.classList[0] != 'selection') {
            return
        }
        const screen_rect = rect.getBoundingClientRect();
        const rect_is_clip = (rect.parentNode.tagName == 'clipPath');

        let x, y, width, height, fill;
        if (!rect_is_clip) {
            x = screen_rect['x'] * dpr;
            y = (screen_rect['y'] - svg_rect['top']) * dpr;
            width = screen_rect['width'] * dpr;
            height = screen_rect['height'] * dpr;
            fill = rect.getAttribute('fill');
        }
        else {
            x = rect.getAttribute('x') * dpr;
            y = rect.getAttribute('y') * dpr;
            width = rect.getAttribute('width') * dpr;
            height = rect.getAttribute('height') * dpr;
            fill = null;
        }

        ctx.beginPath();
        ctx.rect(x, y, width, height);
        if (rect_is_clip) {
            ctx.clip();
        }
        else {
            if (fill === null || fill == 'none') {
                if (fill == 'none') {
                    ctx.restore();
                }
                ctx.lineWidth = dpr;
                ctx.stroke();
            }
            else {
                ctx.fillStyle = fill;
                ctx.fill();
            }
        }
    });

    svg.querySelectorAll('line').forEach(line => {
        const screen_rect = line.getBoundingClientRect();

        const x1 = (screen_rect['x'] - 0.5) * dpr;
        const y1 = (screen_rect['y'] - svg_rect['top'] - 0.5) * dpr;
        const x2 = x1 + screen_rect['width'] * dpr;
        const y2 = y1 + screen_rect['height'] * dpr;
        let stroke_dash = null;

        if (line.getAttribute('stroke-dasharray') !== null) {
            stroke_dash = line.getAttribute('stroke-dasharray').split(',').map(el => el * dpr);
        }

        ctx.beginPath();
        if (stroke_dash !== null) {
            ctx.setLineDash(stroke_dash);
        }
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.lineWidth = dpr;
        ctx.stroke();
    });

    svg.querySelectorAll('text').forEach(text => {
        const drawText = (elem, fontfamily) => {
            const screen_rect = elem.getBoundingClientRect();

            const x1 = screen_rect['x'] * dpr;
            const y1 = (screen_rect['y'] - svg_rect['top'] + 1) * dpr;
            const text = elem.childNodes[0].data;
            let fontsize = elem.getAttribute('font-size');
            if (fontfamily === undefined) {
                fontfamily = elem.getAttribute('font-family');
            }
            let color = elem.getAttribute('fill');
            const transform = elem.getAttribute('transform');

            if (fontsize === null) {
                fontsize = '1em';
            }
            if (fontsize.match(/em$/)) {
                fontsize = fontsize.replace(/em$/, '') * 10;
            }
            fontsize *= dpr;

            if (fontfamily === null) {
                fontfamily = 'sans-serif';
            }

            if (color === null || color == 'currentColor') {
                color = '#000000';
            }

            let rotation = 0;
            let textalign = 'left';
            if (transform !== null) {
                const match = transform.match(/rotate\((-?[\d]+)\)/);
                if (match) {
                    rotation = match[1];
                }

                if (rotation == 270 || rotation == -90) {
                    textalign = 'right';
                }
            }

            ctx.save();
            ctx.translate(x1, y1);
            ctx.rotate(rotation * Math.PI / 180);

            ctx.fillStyle = color;
            ctx.font = fontsize + 'px ' + fontfamily;
            ctx.textBaseline = 'top';
            ctx.textAlign = textalign;
            ctx.fillText(text, 0, 0);

            ctx.restore();
        }

        if ('data' in text.childNodes[0]) {
            drawText(text);
        }
        else {
            const fontfamily = text.getAttribute('font-family');
            text.childNodes.forEach(node => drawText(node, fontfamily));
        }
    });
}

export default svgToCanvas;